import React, { useEffect, useRef } from 'react'
import '../components/Returnrefund.css'

const sections = [
  {
    heading: 'Conditions for Returns and Exchanges',
    list: [
      'Timeframe: Returns or exchanges must be initiated within one day of the delivery date.',
      'Original Condition: The item must be in its original, unworn, and undamaged condition with all tags and packaging intact.',
      'Exclusions: Customized or personalized items, as well as items noted as non-returnable at the time of purchase, are not eligible for return or exchange.',
      'Regards To Any Payment Issues Towards Digi Gold Or Online Shopping, The Process Takes Time Of Minimum 2 Weeks Of Business Days For Verification With The Bank And Payment Gateway Provider.',
    ],
  },
  {
    heading: 'Refund Process',
    list: [
      'Refund Method: All refunds will be issued in the form of a bank cheque.',
      'Processing Time: Refunds will be processed within 3 business days from the date of the returned item being received and inspected.',
      'In case of double payment by mistake or wrong debit from payment gateways, such refunds are processed based on verifications depending on your bank or payment provider, typically within the timeline mentioned in the Refund Policy.',
    ],
  },
  {
    heading: 'Note',
    body: 'MKM THANGAMALIGAI reserves the right to refuse returns or exchanges that do not meet the above conditions or fail to comply with our return policy guidelines.',
  },
]

const ReturnRefund = () => {
  const heroRef = useRef(null)
  const introRef = useRef(null)
  const sectionRefs = useRef([])

  useEffect(() => {
    const targets = [heroRef.current, introRef.current, ...sectionRefs.current].filter(Boolean)

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible')
        })
      },
      { threshold: 0.1 }
    )

    targets.forEach((el, i) => {
      el.style.transitionDelay = `${i * 0.08}s`
      observer.observe(el)
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div className="rr-wrapper">
      {/* Hero */}
      <div className="rr-hero" ref={heroRef}>
        <h1>
          R<span className="SmallLetter">eturn &amp;</span> R<span className="SmallLetter">efund</span>{' '}
          P<span className="SmallLetter">olicy</span>
        </h1>
      </div>

      {/* Body */}
      <div className="rr-body">
        {/* Intro */}
        <p className="rr-intro" ref={introRef}>
          At MKM THANGAMALIGAI, we strive to ensure your satisfaction with every purchase of gold,
          silver and diamond ornaments, and gold savings schemes. If for any reason you are not
          completely satisfied with your purchase, we offer a return or exchange policy within one
          day of the delivery date.
        </p>

        {/* Sections */}
        {sections.map((sec, i) => (
          <div
            key={i}
            className="rr-section"
            ref={(el) => (sectionRefs.current[i] = el)}
          >
            <h2>{sec.heading}</h2>

            {sec.body && <p>{sec.body}</p>}

            {sec.list && (
              <ul>
                {sec.list.map((item, li) => (
                  <li key={li}>
                    <span className="rr-list-num">{li + 1})</span> {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ReturnRefund